<field-string-readonly *ngIf="field.readonly; else editable" [field]="field"></field-string-readonly>
<ng-template #editable>
  <field-string-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-string-single>
</ng-template>
